import React, {Component} from 'react'
import firebase from '../helper/firebase'
import {IconButton} from 'material-ui'
import {Favorite} from '../helper/functions'
import FavoriteIcon from 'material-ui-icons/Favorite'
import FavoriteBorderIcon from 'material-ui-icons/FavoriteBorder'

const style = {
  iconButton:{
    position:'absolute',
    top:0,
    right:0,
  }
}
export default class Fav extends Component{
  constructor(props){
    super(props);

    this.state = {
      uid:this.props.uid,
      oid:this.props.oid,
      job:this.props.job,
      favoriteLoading:false,
    }
  }

  componentWillUnmount(){
    firebase.database().ref(`favorites/${this.state.uid}/${this.state.oid}`).off()
  }

  componentDidMount(){
    firebase.database().ref(`favorites/${this.state.uid}/${this.state.oid}`).on('value',(favorite)=>{
      this.setState({
        favorite:favorite.val(),
        favoriteLoading:false,
      })
    })
  }

  render(){
    if(!!this.state.favorite && !!this.state.favorite.status) return (<IconButton style={style.iconButton} onClick={()=>{Favorite(this.state.uid,this.state.job.jid,this.state.oid,null)}} className='cardActionsBtn' color="accent" aria-label="UnFavorite"><FavoriteIcon>Favorite</FavoriteIcon></IconButton>)
    if(!this.state.favorite || !this.state.favorite.status) return (<IconButton style={style.iconButton} onClick={()=>{Favorite(this.state.uid,this.state.job.jid,this.state.oid,true)}} className='cardActionsBtn' color='default' aria-label="Favorite"><FavoriteBorderIcon>UnFavorite</FavoriteBorderIcon></IconButton>)
  }
}



// WEBPACK FOOTER //
// ./src/components/Fav.js